import type * as React from "react";

/** A modal action button with an arbitrary callback. */
export interface ModalButton {
  label: string;
  variant?: "grey" | "danger" | "primary";
  align?: "left"; // pushed to the left of the action row (default: right-aligned)
  onClick?: () => void | Promise<void>;
}

export interface ModalOptions {
  title: string;
  message: string;
  icon?: React.ReactNode; // large icon shown left of the title
  buttons: ModalButton[];
}

type Listener = (modal: ModalOptions | null) => void;

let listener: Listener | null = null;

/** ModalHost registers itself here; only one host at a time. */
export function registerModalHost(l: Listener): () => void {
  listener = l;
  return () => {
    if (listener === l) listener = null;
  };
}

/** Open a modal dialog (dims the background). Buttons run their callbacks then close. */
export function showModal(opts: ModalOptions): void {
  listener?.(opts);
}

export function closeModal(): void {
  listener?.(null);
}
